// removed by extract-text-webpack-plugin
module.exports = {"Divider":"_1TuiS"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Flight/UI/Mobile/Tuple/TupleDivider/TupleDivider.scss
// module id = 720
// module chunks = 0